import {
  fetchMunicipalitiesWithLinesByTrafficType,
  type MunicipalityWithLines,
} from "./zones";
import type { LineDetails } from "../types";
import { fetchLineDetails } from "./lines";

export type TrafficOverviewLine = {
  id: string;
  lineNrReal: number;
  displayName: string;
  municipality: string;
  trafficGroupKey: string;
  trafficGroupLabel: string;
};

const TRAFFIC_TYPES = [
  // "NÄRTRAFIK",
  //"BÅT",
  //"GÅNG",
  "TÄTO",
  "LAND",
  "EXPRESS",
  "TÅG",
];

export async function getAllLinesGroupedByMunicipality(): Promise<
  TrafficOverviewLine[]
> {
  const out: TrafficOverviewLine[] = [];

  for (const typeKey of TRAFFIC_TYPES) {
    let muni: MunicipalityWithLines[];
    try {
      muni = await fetchMunicipalitiesWithLinesByTrafficType(typeKey);
    } catch (err) {
      continue;
    }

    for (const m of muni) {
      const municipalityName = (m.Key ?? "").trim();

      for (const v of m.Value) {
        const id = String(v.LineNrReal);
        const displayName =
          (v as any)?.Ogt?.OgtLineNamePreformatted?.trim() ||
          `Linje ${v.LineNrReal}`;

        const lineType = (v as any)?.LineType;

        const trafficGroupKey =
          lineType?.OgtTrafficTypeGroupCssClass ??
          lineType?.ParentGroupKey ??
          lineType?.Key ??
          typeKey;

        const trafficGroupLabel = lineType?.Label ?? trafficGroupKey;

        out.push({
          id,
          lineNrReal: v.LineNrReal,
          displayName,
          municipality: municipalityName,
          trafficGroupKey,
          trafficGroupLabel,
        });
      }
    }
  }

  const dedupMap = new Map<string, TrafficOverviewLine>();
  for (const l of out) {
    const key = `${l.id}__${l.municipality}__${l.trafficGroupKey}`;
    if (!dedupMap.has(key)) dedupMap.set(key, l);
  }
  const deduped = Array.from(dedupMap.values());

  deduped.sort((a, b) => {
    const m = a.municipality.localeCompare(b.municipality, "sv");
    if (m !== 0) return m;
    const g = a.trafficGroupLabel.localeCompare(b.trafficGroupLabel, "sv");
    if (g !== 0) return g;
    return a.lineNrReal - b.lineNrReal;
  });

  return deduped;
}

export async function fetchDetailsForLines(
  lines: TrafficOverviewLine[]
): Promise<LineDetails[]> {
  const uniques = Array.from(new Map(lines.map((l) => [l.id, l])).values());

  const details = await Promise.all(
    uniques.map((l) =>
      fetchLineDetails(l.id).catch((err) => {
        console.error("Kunde inte hämta detaljer för linje", l.id, err);
        return null;
      })
    )
  );

  return details.filter((d): d is LineDetails => d != null);
}
